import NetworkConfiguration from 'src/modules/network-configuration';
import WebUiApp from 'src/modules/web-ui';

import { WEB_UI_PATH } from './config';

function App() {
  const path = window.location.pathname || '/';

  if (path === `/${WEB_UI_PATH}` || path.startsWith(`/${WEB_UI_PATH}/`)) {
    return <WebUiApp />;
  }

  return <NetworkConfiguration />;
}

export default App;
